<template>
  <div>
    <!-- <div style="position: absolute; top: 10; left; 10" id="backButton">
      <font-awesome-icon
        @click="$router.go(-1)"
        class="menuIcon"
        icon="arrow-left"
      />
    </div> -->
    <div style="position: absolute; top: 10; left; 10" id="backButton">
      <font-awesome-icon @click="goRouter('/sportsengine')" class="menuIcon" icon="arrow-left" />
    </div>
    <img src="/se_logo_full.png" style="width: 300px; max-width: 90%" />
    <br />
    <div><h1 class="title is-2">Import Data</h1></div>
    <div class="importHeader">Select Site</div>
    <Dropdown
      :filter="true"
      :options="sites"
      optionLabel="name"
      optionValue="id"
      placeholder="Select Site"
      style="width: 300px"
      class="p-mb-2"
      v-model="selectedSite"
      @input="getLeagues"
    />
    <div v-if="selectedSite" class="importHeader">Select League</div>
    <Dropdown
      v-if="selectedSite"
      :filter="true"
      :options="leagues"
      optionLabel="name"
      optionValue="id"
      placeholder="Select League"
      style="width: 300px"
      class="p-mb-2"
      v-model="selectedLeague"
      @input="getSeasons"
    />
    <div v-if="selectedLeague" class="importHeader">Select Season</div>
    <Dropdown
      v-if="selectedLeague"
      :filter="true"
      :options="seasons"
      optionLabel="name"
      optionValue="id"
      placeholder="Select Season"
      style="width: 300px"
      class="p-mb-2"
      v-model="selectedSeason"
      @input="getSeason"
    />
    <div v-if="subseasons.length > 1" class="importHeader">
      Select Subseason
    </div>
    <Dropdown
      v-if="subseasons.length > 1"
      :options="subseasons"
      optionLabel="name"
      optionValue="id"
      placeholder="Select Subseason"
      style="width: 300px"
      class="p-mb-2"
      v-model="selectedSubseason"
    />
    <div class="p-my-3">
      <div class="p-field-checkbox" style="display: block; text-align: center" v-if="selectedSubseason">
        <Checkbox id="binary" v-model="includeGames" :binary="true" />
        <label for="binary">Include Games</label>
        &nbsp; &nbsp; &nbsp;
        <Checkbox id="binary" v-model="includePractices" :binary="true" />
        <label for="binary">Include Practices</label>
        &nbsp; &nbsp; &nbsp;
        <Checkbox id="binary" v-model="includeCoaches" :binary="true" />
        <label for="binary">Include Coaches</label>
      </div>
      <!-- <div
        class="p-field-checkbox"
        style="display: block; text-align: center"
        v-if="selectedSubseason"
      >
        <Checkbox id="binary" v-model="includeCoaches" :binary="true" />
        <label for="binary">Include Coaches</label>
      </div> -->
      <br />
      <Button
        v-if="!isLoading"
        :disabled="!selectedSeason || (subseasons.length && !selectedSubseason)"
        label="Import"
        class="p-button-lg"
        @click="doImport"
      />
      <div v-else>
        <ProgressSpinner />
      </div>
    </div>
    <div>
      <p>Site: {{ selectedSite }}</p>
      <p>League: {{ selectedLeague }}</p>
      <p>Season: {{ selectedSeason }}</p>
      <p>Subseason: {{ selectedSubseason }}</p>
    </div>
    <div v-if="!isProduction">
      <p>Site: <input v-model="selectedSite" /></p>
      <p>League: <input v-model="selectedLeague" /></p>
      <p>Season: <input v-model="selectedSeason" /></p>
      <p>Subseason: <input v-model="selectedSubseason" /></p>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  // ddddd
  data() {
    return {
      includeGames: false,
      includePractices: false,
      includeCoaches: false,
      sites: [],
      leagues: [],
      seasons: [],
      subseasons: [],
      isLoading: true,
      selectedSite: null,
      selectedLeague: null,
      selectedSeason: null,
      selectedSubseason: null,
    };
  },
  computed: {},
  methods: {
    doImport() {
      this.isLoading = true;
      api
        .importSportsEngine(
          this.selectedLeague,
          this.selectedSeason,
          this.selectedSubseason,
          this.includeGames,
          this.includePractices,
          this.includeCoaches,
        )
        .then(response => {
          this.po(response.data);
          this.isLoading = false;
          // this.makeToast("success", "Successfully Imported");
          // this.setCurrentLeagueSeasonId(
          //   response.data.season.league_id,
          //   response.data.season.id
          // );
          // this.refreshLeagueInformation("/");
          if (true || this.isProduction) {
            this.goRouter("/activity/" + response.data.activity.id);
          }
        })
        .catch(e => {
          console.log(e);
          this.makeToast("error", "Could not import league");
          this.isLoading = false;
        });
    },
    getSites() {
      console.log("GetSites");
      api
        .getSESites()
        .then(response => {
          console.log("Sites", response);
          this.sites = response.data.sort(this.dynamicSort("name"));
          this.selectedLeague = null;
          this.selectedSeason = null;
          this.selectedSubseason = null;
          this.isLoading = false;
          this.selectedSite = this.sites[0].id;
          this.getLeagues();
        })
        .catch(e => {
          alert(
            "Please re-connect your SportsEngine account to continue. If you do not own this Diamond Scheduler account (e.g. you are staff), DO NOT connect your SE account. Ask the account owner to login and re-connect.",
          );
          this.isLoading = false;
          this.goRouter("/sportsengine");
        });
    },
    getLeagues() {
      api
        .getSELeagues(this.selectedSite)
        .then(response => {
          console.log("Leagues", response);
          this.selectedSeason = null;
          this.selectedSubseason = null;
          this.leagues = response.data.sort(this.dynamicSort("name"));
          this.isLoading = false;
          if (!this.isProduction) {
            this.selectedLeague = 89595;
            this.selectedSeason = 136117;
            this.selectedSubseason = 735354;
            this.getSeasons();
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    getSeasons() {
      api
        .getSESeasons(this.selectedLeague)
        .then(response => {
          console.log("Seasons", response);
          this.seasons = response.data.sort(this.dynamicSort("name"));
          this.selectedSeason = this.seasons[0].id;

          this.getSeason();
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getSeason() {
      api
        .getSESeason(this.selectedSeason)
        .then(response => {
          console.log("Subseasons", response);
          this.subseasons = response.data.sort(this.dynamicSort("name"));
          this.selectedSubseason = this.subseasons[0].id;
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
  },
  created() {},
  mounted() {
    this.getSites();
    window.analytics.page();
    this.trackEvent("Opened SportsEngine Import", {});
  },
};
</script>

<style scoped lang="scss">
.importHeader {
  margin-top: 10px;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 1.4em;
}
</style>
